// Surfsight Camera Domain Configuration
export const lytxstoreConfig = {
  // Basic domain information
  id: 'lytxstore',
  name: 'Lytx Store',
  tagline: 'Smart, connected fleet management solutions',
  description: 'Transform your business with the power of video.',
  
  // Assets
  logo: '/assets/logos/lytxstore-logo.png',
  whiteLogo: '/assets/logos/lytxstore-white-logo.png',
  favicon: '/assets/favicons/lytxstore-favicon.png',
  icon: '/assets/icons/lytxstore',
  
  // Navigation
  pages: ['home', 'solutions', 'products', 'blog'],
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Products', path: '/products' },
    { name: 'Blog', path: '/blog' },
  ],
  
  // CTAs
  cta: {
    primary: 'Request Demo',
    secondary: 'Buy Now'
  },
              
  // Shop link
  shopLink: 'https://shop.fleethoster.com/collections/surfsight-lytx',

  // UI Configuration
  variant: 'elegant',
  showFeatures: false,
  showTestimonials: false,
  
  // Content sections
  hero: {
    title: 'Lytx Store',
    subtitle: 'Find everything you need for your fleet in one place. From cameras to tracking devices, we have it all.',
    features: ['Live streaming', 'A.I.-ready', 'Driver coaching feature', 'Built-in storage and cloud storage']
  },
  
  // Gallery/Image Slider configuration
  gallery: {
    title: 'Lytx Store Solution',
    subtitle: 'Explore our professional fleet camera and video management solutions',
    description: 'See our comprehensive range of Lytx fleet safety and video technology'
  },

  features: {
    title: 'Lytx Store Features',
    subtitle: 'Complete professional dash cam and accessories store with comprehensive solutions for all your needs.',
    description: 'Lytx store offers everything you need for your fleet in one place. From cameras to tracking devices, we have it all.',
    items: [
      {
        title: 'Operational Transparency',
        description: 'See what’s happening on the road and inside the vehicle in real-time.',
        icon: '📺'
      },
      {
        title: 'Streamlined Incident Management',
        description: 'Identify and analyze incidents to reduce risk and improve safety.',
        icon: '🚨'
      },
      {
        title: 'Cost Reduction',
        description: 'Reduce costs by improving efficiency and reducing incidents.',
        icon: '💰'
      },
      {
        title: 'Productivity and Efficiency',
        description: 'Optimize routes and reduce downtime with real-time data.',
        icon: '👨‍💻'
      },
      {
        title: 'Driver Coaching Feature',
        description: 'Coach drivers to improve their driving behavior and reduce incidents.',
        icon: '👨‍🏫'
      },
      {
        title: 'Built-in Storage and Cloud Storage',
        description: 'Store and manage videos with built-in storage and cloud storage.',
        icon: '📊'
      }
    ]
  },
  
  solutions: {
    title: 'Lytx Store Advanced Solutions',
    subtitle: 'Tailored solution for your business needs',
    description: 'Lytx store offers everything you need for your fleet in one place. From cameras to tracking devices, we have it all.',
    sections: [
      {
        title: 'Put Safety in the Driver’s Seat',
        description: 'Every trip your fleet takes matters—to your drivers, your customers, and your business. Lytx® gives you the technology you need to protect them all. With advanced fleet safety solutions powered by cutting-edge artificial intelligence and proven insights, you’ll not only help prevent risk—you’ll transform the way your fleet operates.',
      },
      {
        title: 'GPS Fleet Tracking Software with Video',
        description: 'A contextually rich fleet tracking solution that provides the visibility and actionable insights you need to get more done each day and eliminate wasteful spending.',
      },
      {
        title: 'Effortless ELD Compliance Reporting',
        description: 'Lytx® can help you keep your drivers and fleet compliant with government mandates to avoid violations that waste money and may damage your fleet’s reputation.',
      }
    ]
  },

  testimonials: [
    {
      content: "Surfsight Camera has revolutionized how we manage our fleet. The real-time insights are invaluable for our day-to-day operations.",
      author: "John Thomas",
      role: "Fleet Manager",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg"
    },
    {
      content: "Lytx analytics capabilities have helped us reduce costs and improve efficiency significantly. One of the best investments we've made.",
      author: "Timothy Soh",
      role: "Operations Director",
      company: "",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg"
    }
  ],

  blog: {
    title: 'Lytx Store Blog',
    subtitle: 'Latest News and Insights',
    description: 'Stay informed with the latest news and insights in fleet management and industry best practices.',
  },

  products: {
    title: 'Lytx Store Products',
    subtitle: 'Discover our comprehensive range of dashcam solutions designed to optimize your operations.',
    categories: [
      { id: 'all', name: 'All Products' },
      { id: 'cameras', name: 'Cameras' },
      { id: 'aux', name: 'Auxiliary' },
      { id: 'harnesses', name: 'Harnesses' },
      { id: 'monitor', name: 'Monitors' },
    ],
    items: [
      {
        id: 7,
        title: 'Surfsight AI-12 DCC07-12',
        description: 'The DCC07-12 brings you the most advanced reporting features currently available in the video dash camera market.',
        brand: 'Surfsight',
        category: 'cameras',
        productLink: 'https://shop.fleethoster.com/products/dcc07-12',
        image: 'product-7',
        featured: true,
        details: [
          {
            title: 'Introducing',
            description: 'Now with DCC07-12 you can set up rules inside of your database that manage events and video for you! Maybe you don’t want videos downloaded anytime a vehicle goes 10mph over the posted speed limit. Set a rule to note it but not download the video. Furthermore, you can create a rule for detected collision to automatically record 10 seconds before and after the event and automatically download videos you want. It’s all about efficiency for your staff and data (both can be costly). You want live video to protect your company accurately and efficiently—this DCC07-12 kit gives exactly that!',
            features: []
          },
          {
            title: 'What makes this system special?',
            description: '',
            features: [
              'Live streaming',
              'IR night-vision',
              'Distracted driver detection',
              'Wi-Fi hotspot connectivity for up to 4 additional wireless cameras',
              'Driver coaching feature',
              'A.I.-ready',
              'Panic button',
              'Tamper detection', 
              'Built-in storage and cloud storage',
              'Parking mode',
              'SIM and SD card lock',
              'Over-the-air upgrades',
              '10-minute installation',
              'Integrated into Geotab'
            ]
          },
          {
            title: 'Hardware Features',
            description: '',
            features: [
              'Adjustable event/trigger setting levels to get videos when you want them',
              'Parking mode allows you to record an event even with ignition off',
              'Automatic server upload based on events prevents driver tampering of SD card',
              'Can be used as both GPS telematics device & dashcam in one sleek device',
              'Integrated into Geotab so any vehicle rule can trigger a video event from camera'
            ]
          },
          {
            title: 'Product Specifications',
            description: '',
            features: [
              'Live stream, Dual IR, Distracted Driver detect, WiFi hotspot connectivity for more cameras',
              'Forward & Rear facing dual cam w/ IR + Optional cameras for WiFi expandability',
              'Live Stream, Event-based, 30-day backup',
              'Input Voltage - 5V 2amp',
              'Operating Temperature - -10°C to +85°C (14°F to +185°F)',
              'Hardwire or OBD2 plug & play',
              'HD 1080p road facing',
              '720p driver facing',
            ]
          }
        ]
      },
      {
        id: 22,
        title: 'DCA01-SC Auxiliary Side Camera',
        description: 'An auxiliary side camera designed to enhance fleet security and visibility with HD resolution and night vision capabilities.',
        category: 'aux',
        productLink: 'https://shop.fleethoster.com/products/dca01-sc',
        image: 'product-22',
        featured: true,
        details: [
          {
            title: 'Product Description',
            description: 'The DCA01-SC is an auxiliary side camera designed to enhance fleet security and visibility. This camera is ideal for capturing side views of vehicles, improving situational awareness and safety during fleet operations.',
            features: [
              '1080p HD resolution',
              'Night vision capabilities',
              'Rugged design',
              'Compatibility with FleetFlix AI+ and SurfSight AI-12 systems'
            ]
          },
          {
            title: 'Hardware Features',
            description: '',
            features: [
              'IP66-rated durability for outdoor use',
              'Expandable coverage with support for up to 4 auxiliary cameras',
              'Optional magnetic mounts for easy installation',
              'Customizable event triggers for specific scenarios',
              'Automated event uploads to a server',
              'Seamless integration into Geotab'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Tech Available: Live stream, Dual IR, 1080p, Nighttime view',
              'Video Availability: Live stream, Event-based',
              'Input Voltage: 12V, 2 amp',
              'Operating Temperature: −10°C to +85°C',
              'Installation Methods: Hardwire powered',
              'Video: Road capture in HD 1080p',
              'IP Rating: IP66 (dust-tight and protected against powerful water jets)'
            ]
          }
        ]
      },
      {
        id: 9,
        title: 'DCA01-FFLITE-RC-AHD Aux Cam',
        description: 'FleetFlix Lite auxiliary cameras that connect to FleetFlix Lite and FleetFlix Lite Pro+ dashcams, providing 360° video coverage with HD recording from multiple vehicle perspectives.',
        category: 'aux',
        productLink: 'https://shop.fleethoster.com/products/dca01-fflite-rc-ahd',
        image: 'product-9',
        featured: false,
        details: [
          {
            title: 'Product Description',
            description: 'FleetFlix Lite auxiliary cameras are connected to FleetFlix Lite and FleetFlix Lite Pro+ dashcams. When connected to the dash camera, the cameras enable live video and recording from additional perspectives during trips. The cameras are installed around the vehicle in key locations (side and rear). All auxiliary cameras include a high-definition 1920×1080 lens, auto gain, 3D noise reduction, and backlight compensation. They provide 360° video coverage for the fleet.',
            features: []
          },
          {
            title: 'Key Features',
            description: '',
            features: [
              'Image sensor: 1/2.8" 2.13M pixel CMOS',
              'Resolution: 1920H × 1080V',
              'Minimum illumination: 0LUX (IR on); 0.05LUX (IR off)',
              'Auto electronic shutter, auto exposure, and auto white balance',
              'IR range: 10M (12 Q5 850NM LED dots)',
              'IP rating: IP67',
              'Includes a 0.5M waterproof aviation cable, DC12V black shell',
              'White balance auto tracking'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Signal-to-noise ratio: ≥50dB',
              'Electronic shutter speed: 1/25s ~ 1/25,000s (auto)',
              'Day/night mode: ICR IR filter',
              'Operating temperature: -40°C to +70°C',
              'Operating humidity: <95% (no condensation)',
              'Power supply: DC12V ±10%',
              'Dimensions: 3 in × 2.5 in × 2.9 in (75mm × 65.1mm × 73.7mm)',
              'Weight: 0.6 lbs (280g)',
              'Power consumption: ~130mA / DC12V ±5%'
            ]
          },
          {
            title: 'Lens Options',
            description: '',
            features: [
              '2.5mm M12@ F2.0; HFOV: 123°, VFOV: 69°, DFOV: 141°',
              '2.8mm M12@ F2.0; HFOV: 103°, VFOV: 56°, DFOV: 121°',
              '3.6mm M12@ F2.2; HFOV: 88°, VFOV: 49°, DFOV: 103°',
              'Other lens options with varying fields of view available',
              'Composite video output at various specifications'
            ]
          }
        ]
      },
      {
        id: 10,
        title: 'DCA01-FFLITE-SC-CA39-AHD Aux Cam',
        description: 'High-definition auxiliary camera compatible with FleetFlix Lite systems, offering 360° video coverage with advanced features like auto gain and 3D noise reduction.',
        category: 'aux',
        productLink: 'https://shop.fleethoster.com/products/dca01-lite-sc-ahd',
        image: 'product-10',
        featured: false,
        details: [
          {
            title: 'Product Description', 
            description: 'FleetFLIX Lite auxiliary cameras are connected to FleetFLIX Lite and FleetFLIX Lite Pro+ dashcams. When connected to the dash camera, the cameras enable live video and recording from the portal of additional perspectives during trips. The cameras are installed around the vehicle in key locations (side and rear). All auxiliary cameras include a high-definition 1920×1080V lens. Auto gain, 3D noise reduction, and backlight compensation are all supported. Provide your fleet with 360° video coverage.',
            features: []
          },
          {
            title: 'Key Features',
            description: '',
            features: [
              'Image sensor: 1/2.8" 2.13M pixel CMOS',
              'Resolution: 1920H × 1080V',
              'Minimum illumination: 0LUX (IR on), 0.05LUX (IR off)', 
              'Auto electronic shutter, auto exposure, and auto white balance',
              'IR range: 10–15M',
              'IP rating: IP69K',
              'Compact design and simple installation',
              'Vehicle damping performance optimization'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Signal-to-noise ratio: ≥50dB',
              'Electronic shutter: 1/25s ~ 1/25,000s (auto)',
              'Day/night mode: ICR IR filter',
              'Operating temperature: -40°C to +70°C',
              'Operating humidity: <95% (no condensation)',
              'Power supply: DC12V ±10%',
              'Video output: 1.0VP-P composite, 75Ω, 4PIN aviation cable',
              'Power consumption: 260mA / DC12V ±5%',
              'Dimensions: 2.59 in × 2.29 in × 1.8 in (66mm × 58mm × 46mm)',
              'Weight: 0.39 lbs (180g)'
            ]
          },
          {
            title: 'Lens Options',
            description: '',
            features: [
              '2.2mm M12@ F2.0 (HFOV: 152°, VFOV: 83°, DFOV: 180°)',
              '2.8mm M12@ F2.0 (HFOV: 103°, VFOV: 56°, DFOV: 121°)',
              '3.6mm M12@ F2.2 (HFOV: 88°, VFOV: 49°, DFOV: 103°)'
            ]
          }
        ]
      },
      {
        id: 1,
        title: 'Geotab GO9 Device',
        description: 'Advanced telematics device with 4G connectivity, GPS tracking, and comprehensive vehicle diagnostics.',
        category: 'trackers',
        productLink: 'https://shop.fleethoster.com/products/vtd12-go9',
        image: 'product-1',
        featured: false,
        details: [
          {
            title: 'Precise GPS tracking',
            description: 'Collect precise data on vehicle location, speed, trip distance and time, engine idling and more with the GO9. Even if you park a vehicle indoors and underground, advanced GPS vehicle tracking and telematics starts recording as soon as you begin driving. The GO9 introduces the new Global Navigation Satellite System module (GNSS) for faster latch times and increasingly accurate location data.',
            features: []
          },
          {
            title: 'Vehicle health assessments',
            description: 'Extract valuable vehicle health information within our fleet vehicle tracking system. Capture and record the vehicle identification number (VIN), odometer reading, engine faults and more. This data helps you prioritize vehicle fleet maintenance and audit vehicle use to identify both safe and risky driving behaviors.',
            features: []
          },
          {
            title: 'Collision detection and notification',
            description: 'GO9 offers harsh-event data (such as aggressive acceleration, harsh braking or cornering) and collision reconstruction through its accelerometer and our patented algorithms. If GO9 detects a suspected collision, it will automatically upload detailed data that enables forensic reconstruction of the event. This includes in-vehicle reverse collisions. Email and desktop alerts signal the first notice of loss.',
            features: []
          },
          {
            title: 'Secured data',
            description: 'Geotab uses authentication, encryption and message integrity verification for GO9 vehicle tracking devices and network interfaces. Each GO9 device uses a unique ID and non-static security key, making it difficult to fake a device’s identity. Over-the-air (OTA) updates use digitally signed firmware to verify that updates come from a trusted source.',
            features: []
          },
          {
            title: 'In-vehicle driver coaching',
            description: 'Improve driving behaviors, such as following speed limits and reducing idling time, by playing an audible alert. GO9 also enables you to coach the driver with spoken words (available as an Add-On). Immediate driver feedback can enhance fleet safety, reinforce company policy and encourage your drivers to take immediate corrective action.',
            features: []
          },
          {
            title: 'Advanced data capture',
            description: 'Vehicles send data from a multitude of sources, including the engine, drivetrain, instrument cluster and other subsystems. Utilizing multiple internal networks, the GO9 captures and organizes much of this data.',
            features: []
          }
        ]
      },
      {
        id: 23,
        title: '7-inch HD Fleet Monitor',
        description: 'High-definition 7-inch monitor designed for fleet vehicles, featuring dual-channel support, IPS display, and rugged construction for enhanced driver visibility and safety.',
        category: 'monitor',
        productLink: 'https://shop.fleethoster.com/products/acc01-lite-mon-7hd',
        image: 'product-23',
        featured: true,
        details: [
          {
            title: 'Product Description',
            description: 'The 7-inch high-definition monitor enhances the driver\'s ability to observe vehicle operations and the surrounding environment clearly, improving both safety and efficiency. With simple button operation, high resolution and brightness, high contrast, and wide viewing angle, this monitor is suitable for various driving scenarios, improving the driving experience and vehicle operating efficiency.',
            features: []
          },
          {
            title: 'Features',
            description: '',
            features: [
              'Dual-channel support with 2 video inputs and dual/single image segmentation display',
              'IPS screen with fast response speed, wide viewing angle, and true color (1024 RGB × 600 resolution)',
              'OSD menu for mirror/normal image settings, delay time configuration, and trigger priority management',
              'Rugged design with high-temperature resistant ABS + PC materials',
              'Removable sun hat to reduce glare from direct sunlight',
              'Rust-proof metal bracket with U-shaped double-sided fastening and anti-vibration design',
              'High brightness of 600 cd/㎡ for clear image visibility',
              'Load dump pulse voltage protection (DC 24V + 174V for 350 ms)',
              'Energy-efficient power supply with low-temperature stability',
              'Wide voltage range operation (DC 11–32V)',
              'Built-in reverse polarity protection with LED thermal response'
            ]
          },
          {
            title: 'Technical Specifications',
            description: '',
            features: [
              'Screen Size: 7 inches (177 mm)',
              'Color System: AHD 720P / 1080P',
              'Display Resolution: 1024 RGB(H) × 600(V)',
              'Viewable Area: 154.4 mm × 85.9 mm',
              'Brightness: 600 cd/㎡',
              'Contrast Ratio: 700:1',
              'Viewing Angle: 160° / 160°',
              'LED Power: 8.7V / 220mA',
              'Maximum Power Consumption: 5W',
              'Operating Voltage: DC 11–32V',
              'Operating Temperature: −20°C to +70°C (−4°F to +158°F)',
              'Storage Temperature: −30°C to +80°C (−30°F to +176°F)',
              'Motherboard Chipset: ATM630M',
              'Power Output: DC 10.5V / 750mA',
              'Dimensions: 8.5 in × 5.9 in × 3.3 in (216 mm × 150 mm × 85 mm)',
              'Net Weight: 28.2 oz (800 g)'
            ]
          }
        ]
      },
      {
        id: 12,
        title: 'Harness 3WOBDK',
        description: '',
        category: 'harnesses',
        productLink: 'https://shop.fleethoster.com/products/hrn01-3wobdk',
        image: 'product-12',
        featured: false
      },
      // {
      //   id: 13,
      //   title: 'Harness 4W6POBDK',
      //   description: '',
      //   category: 'harnesses',
      //   productLink: 'https://shop.fleethoster.com/products/hrn01-4w6pobdk',
      //   image: 'product-13',
      //   featured: false
      // },
      {
        id: 14,
        title: 'Harness 4W9POBDK',
        description: '',
        category: 'harnesses',
        productLink: 'https://shop.fleethoster.com/products/hrn01-4w9pobdk',
        image: 'product-14',
        featured: false
      },
      {
        id: 15,
        title: 'Harness 4WOBDK',
        description: '',
        category: 'harnesses',
        productLink: 'https://shop.fleethoster.com/products/hrn01-4wobdk',
        image: 'product-15',
        featured: false
      },
    ],
  },
  
  // SEO and Meta
  seo: {
    // Basic Meta Tags
    title: 'Lytx Store - Advanced Fleet Management Solutions',
    description: 'Transform operations with cutting-edge tracking: real-time GPS, fleet management, and business intelligence for optimal performance.',
    keywords: [
      'surfsight camera', 'camera', 'fleet tracking', 'fleet management', 'business intelligence', 'fleet optimization', 'real-time tracking',
      'professional dashcam', 'AI-powered camera', 'dash cam solutions', 'dash cam systems', 'dash cam technology',
      'fleet analytics', 'vehicle tracking', 'fleet monitoring', 'lytx dashcam', 'lytx camera',
      'fleet solutions', 'fleet intelligence', 'lytx store', 'lytx', 'lytxstore', 'lytx dashcam solutions', 'lytx camera solutions',
    ],
    
    // Open Graph & Social Media
    ogTitle: 'Lytx Store - Advanced Fleet Management Solutions',
    ogDescription: 'Advanced tracking solutions for fleet optimization and business intelligence. Real-time insights and performance analytics.',
    ogType: 'website',
    ogUrl: 'https://lytxstore.com',
    
    // Twitter Cards
    twitterCard: 'summary_large_image',
    twitterTitle: 'Lytx Store - Advanced Fleet Management Solutions',
    twitterDescription: 'Advanced tracking solutions for fleet optimization and business intelligence. Real-time insights and performance analytics.',
    
    // Robots
    robots: 'index, follow',
    author: 'Lytx Store',
    publisher: 'Lytx Store',
    
    // Page-Specific SEO
    pages: {
      home: {
        title: 'Lytx Dash Cams & Video Safety Solutions | Lytx Store',
        description: 'Transform your operations with cutting-edge tracking solutions. Real-time GPS tracking, fleet management, and business intelligence.',
        keywords: ['lytx store', 'fleet tracking', 'asset management', 'business intelligence', 'fleet optimization']
      },
      solutions: {
        title: 'Lytx Solutions | Video Telematics & Fleet Safety Solutions',
        description: 'Comprehensive fleet tracking solutions and asset management services. Real-time monitoring, analytics, and optimization tools.',
        keywords: ['fleet tracking solutions', 'asset management services', 'fleet monitoring', 'tracking analytics']
      },
      blog: {
        title: 'Lytx Store Blog | Fleet Safety Tips & Compliance Insights',
        description: 'Latest news, insights, and best practices for fleet tracking and asset management. Industry updates and optimization tips.',
        keywords: ['lytx store news', 'fleet management insights', 'tracking best practices', 'fleet optimization tips']
      }
    },
    
    // Performance & Technical SEO
    technical: {
      pageLoadTime: '< 1 second',
      mobileOptimized: true,
      sslEnabled: true,
      schemaMarkup: true,
      xmlSitemap: true,
      robotsTxt: true,
      compressionEnabled: true,
      imageOptimization: true,
      cdnEnabled: true
    },

    // Local Business Info for Structured Data
    localBusiness: {
      streetAddress: '',
      addressLocality: 'Atlanta',
      addressRegion: 'GA',
      postalCode: '30308',
      addressCountry: 'US'
    }
  }
};
